import { render } from "./CoursePlayer.vue?vue&type=template&id=a9f661ac"
import script from "./CoursePlayer.vue?vue&type=script&lang=js"
export * from "./CoursePlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/lie/repo/blisspot_vue_app/nuron-vuejs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__